<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-center" style="width: 80px">商品ID</th>
          <th class="text-center" style="min-width: 100px">商品コード</th>
          <th class="text-center" style="min-width: 150px">商品名</th>
          <th></th>
          <th class="text-center" style="width: 150px" />
        </tr>
      </thead>
      <tbody>
        <tr v-for="product in products" :key="product.id">
          <td class="text-center p-productTable__td">{{ product.id }}</td>
          <td class="text-center p-productTable__td">{{ product.identificationCode }}</td>
          <td class="p-productTable__td py-1">
            <div class="d-flex">
              <div class="p-productTable__td__imageWrap">
                <img
                  v-if="productEyecatch(product)"
                  :src="productEyecatch(product).imageUrl"
                  :alt="productEyecatch(product).altAttribute"
                  class="p-productTable__td__image"
                />
                <img
                  v-else
                  src="https://placehold.jp/eeeeee/cccccc/200x200.png?text=No%20Image"
                  alt="no-image"
                  class="p-productTable__td__image"
                />
              </div>

              <span class="p-productTable__td__imageContent">
                {{ product.name }}
              </span>
            </div>
          </td>
          <td>
            <v-chip v-if='product.published' outlined color='green'>公開</v-chip>
            <v-chip v-else  outlined color='red'>非公開</v-chip>
          </td>
          <td class="text-center px-1 p-productTable__td">
            <v-btn
              class="editLink ma-2"
              :to="productEditPath(product)"
              tile
              small
              color="primary"
            >
              <v-icon left small> mdi-pencil </v-icon>
              編集
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'ProductTable',
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  methods: {
    productEditPath (product) {
      return `/admin/products/${product.id}/edit`
    },
    productEyecatch (product) {
      if (!product.productImages) return
      return product.productImages.reduce((previousImage, currentImage) =>
        previousImage.priority > currentImage.priority
          ? currentImage
          : previousImage
      )
    }
  }
}
</script>

<style scoped>
.p-productTable__td {
  vertical-align: middle;
}

.p-productTable__td__imageWrap {
  height: 120px;
  width: 120px;
  display: flex;
  align-items: center;
  margin-right: 10px;
}
.p-productTable__td__image {
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.p-productTable__td__imageContent {
  place-self: center;
}
</style>
